var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_738_38557",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_738_38557)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66669 17.291C1.66669 16.9458 1.94651 16.666 2.29169 16.666H17.2917C17.6369 16.666 17.9167 16.9458 17.9167 17.291C17.9167 17.6362 17.6369 17.916 17.2917 17.916H2.29169C1.94651 17.916 1.66669 17.6362 1.66669 17.291Z",
    fill: "#366EE3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5812 1.66602C12.7471 1.66598 12.9061 1.73187 13.0234 1.84917L16.0671 4.89421C16.311 5.13827 16.311 5.53385 16.0671 5.7779L7.44925 14.3995C7.33203 14.5168 7.17302 14.5827 7.00721 14.5827H3.95837C3.6132 14.5827 3.33337 14.3029 3.33337 13.9577V10.9243C3.33337 10.7587 3.39912 10.5998 3.51617 10.4826L12.1391 1.84934C12.2563 1.732 12.4154 1.66605 12.5812 1.66602ZM12.5815 3.17526L4.58337 11.183V13.3327H6.74824L14.7414 5.33606L12.5815 3.17526Z",
    fill: "#366EE3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit_blue.e5077853e56f059c7b3e8a59f6758359.svg";
export { ForwardRef as ReactComponent };